export default "__VITE_ASSET__CPjY_vfM__"